import { NotificationDateTimeParts } from '../models/notification.model';

const SAO_PAULO_TIMEZONE = 'America/Sao_Paulo';

/**
 * Formata data/hora de notificação em duas linhas:
 * "Sábado, 04/07/2026" e "19:56:00"
 * @param value Data ISO ou objeto Date
 */
export function formatNotificationDateTimeParts(
  value: string | Date | null | undefined
): NotificationDateTimeParts {
  if (!value) {
    return { dateLine: '-', timeLine: '' };
  }

  const date = typeof value === 'string' ? new Date(value) : value;

  if (Number.isNaN(date.getTime())) {
    return { dateLine: '-', timeLine: '' };
  }

  const weekday = new Intl.DateTimeFormat('pt-BR', {
    timeZone: SAO_PAULO_TIMEZONE,
    weekday: 'long'
  }).format(date);

  const capitalizedWeekday = weekday.charAt(0).toUpperCase() + weekday.slice(1);

  const dateStr = new Intl.DateTimeFormat('pt-BR', {
    timeZone: SAO_PAULO_TIMEZONE,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).format(date);

  const timeStr = new Intl.DateTimeFormat('pt-BR', {
    timeZone: SAO_PAULO_TIMEZONE,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }).format(date);

  return {
    dateLine: `${capitalizedWeekday}, ${dateStr}`,
    timeLine: timeStr
  };
}

/**
 * Formata data/hora de leitura: "Lido em dd/mm/aaaa - hh:mm:ss"
 * @param value Data ISO ou objeto Date
 */
export function formatNotificationReadAtLabel(
  value: string | Date | null | undefined
): string {
  if (!value) {
    return 'Lido';
  }

  const date = typeof value === 'string' ? new Date(value) : value;

  if (Number.isNaN(date.getTime())) {
    return 'Lido';
  }

  const dateStr = new Intl.DateTimeFormat('pt-BR', {
    timeZone: SAO_PAULO_TIMEZONE,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).format(date);

  const timeStr = new Intl.DateTimeFormat('pt-BR', {
    timeZone: SAO_PAULO_TIMEZONE,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }).format(date);

  return `Lido em ${dateStr} - ${timeStr}`;
}
